export const companyLandingPaths = {
	signUp: () => '/',
	caseRequest: (requestId: string) => `/case-request/${requestId}`,
	requestSubmitted: () => '/request-submitted',
};
